import React from 'react';
import BarGraph from '../Bar/BarGraph';

const StackedBarGraph = (props) => <BarGraph stacked {...props} />;

export default StackedBarGraph;
